// Données pour les différentes sections de services

export const serviceData = [
  {
    id: 0,
    badge: "Nos services",
    titleLines: ["Une suite", "de solutions", "digitales pour", "votre croissance"],
    description: "Nous développons des solutions digitales complètes qui répondent aux besoins de votre entreprise. Notre approche centrée sur l'expérience utilisateur garantit des interfaces fluides et agréables à utiliser.",
    buttonText: "Découvrir nos services"
  },
  {
    id: 1,
    badge: "Sites web",
    titleLines: ["Création de", "sites internet", "performants"],
    description: "Nous concevons des sites web sur-mesure qui répondent parfaitement à vos objectifs commerciaux. Notre expertise technique et notre sens du design nous permettent de créer des sites modernes, responsives et optimisés pour le référencement.",
    buttonText: "Voir nos réalisations"
  },
  {
    id: 2,
    badge: "Hébergement",
    titleLines: ["Hébergement", "performant et", "sécurisé"],
    description: "Nous proposons des solutions d'hébergement web optimisées pour vos projets, avec une haute disponibilité, des temps de chargement rapides et une sécurité renforcée. Nos serveurs sont configurés pour offrir les meilleures performances.",
    buttonText: "Découvrir nos offres"
  },
  {
    id: 3,
    badge: "Identité visuelle",
    titleLines: ["Création de logo", "et identité", "de marque"],
    description: "Nous concevons des logos distinctifs et mémorables qui reflètent l'essence de votre marque. Notre approche créative combine recherche, stratégie et design pour créer une identité visuelle cohérente et impactante.",
    buttonText: "Voir notre portfolio"
  },
  {
    id: 4,
    badge: "Automatisation",
    titleLines: ["Automatisation", "avec Make pour", "votre business"],
    description: "Nous créons des flux de travail automatisés avec Make (anciennement Integromat) pour optimiser vos processus métier. Connectez vos applications, automatisez les tâches répétitives et gagnez en efficacité opérationnelle.",
    buttonText: "Découvrir l'automatisation"
  }
];
